import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { io } from "socket.io-client";
import api from "../api/api";

const useSensorData = ({ fieldId }) => {
  const [sensorData, setSensorData] = useState([]);
  const [allDataSensor, setAllDataSensor] = useState([]);
  const [socket, setSocket] = useState(null);
  let location = useLocation();
  let userId = location.pathname.split("/")[2];
  let userUid = JSON.parse(localStorage.getItem("user"))?.id;
  let fieldUid =
    useParams().id || location.pathname.split("/")[3] || fieldId || null;

  if (!fieldUid) {
    console.warn("fieldUid is undefined in useSensorData");
  }
  console.log(fieldUid, " fieldUid in useSensorData data object");
  let url = "/sensor/sensor-update-data";

  if (location.pathname === `/Sensors/${fieldUid}`) {
    fieldUid = fieldId;
    console.log(fieldUid, " fieldUid in useSensorData useEffect");
  }

  if (
    JSON.parse(localStorage.getItem("user"))?.role === "ROLE_SUPPLIER" &&
    location.pathname === `/Fields/${userId}/${fieldUid}`
  ) {
    url = "/supplier/sensor-data";
  }

  if (
    JSON.parse(localStorage.getItem("user"))?.role === "ROLE_SUPPLIER" &&
    location.pathname === `/Dashboard-supplier`
  ) {
    url = "/supplier/get-sensors-data";
  }

  let data = {
    userUid: userUid,
    fieldUid: fieldUid,
    userId: userId,
  };
  console.log(fieldUid, " fieldUid in useSensorData data object");

  const getDataSensor = async () => {
    try {
      const response = await api.post(url, data);
      const sensors = response.data.sensors;
      const dataMappings = response.data.dataMapping || [];
      const updatedSensorData = sensors.map((sensor) => {
        let mappedCharge = null;

        if (sensor && sensor.charge !== undefined && sensor.charge !== null && sensor.charge !== "") {
          const rawCharge = Number(sensor.charge);
          const usesBufferedFirmware = Boolean(
            sensor.reading_id || sensor.timestamp_arduino,
          );
          const chargeMin = 73;
          const chargeMax = 100;

          if (Number.isFinite(rawCharge)) {
            mappedCharge = usesBufferedFirmware
              ? Math.max(0, Math.min(100, rawCharge))
              : Math.max(
                  0,
                  Math.min(
                    100,
                    ((rawCharge - chargeMin) / (chargeMax - chargeMin)) * 100,
                  ),
                );
            mappedCharge = Number(mappedCharge.toFixed(2));
          }
        }

        return {
          code: sensor.code,
          sensor_id: sensor.sensor_id,
          time: sensor.time,
          temperature: sensor.temperature,
          humidity: sensor.humidity,
          pressure: sensor.pressure,
          environment: sensor.environment || null,
          charge: mappedCharge,
          reading_id: sensor.reading_id,
          timestamp_arduino: sensor.timestamp_arduino,
          signal: sensor.signal,
          adc: sensor.adc,
          ts: sensor.ts,
          // Backend calibration is the source of truth for the live state and
          // the historical graph. Raw device readings stay available separately.
          mv1: sensor.mv1,
          mv2: sensor.mv2,
          mv3: sensor.mv3,
          originalmv1: sensor.niv1 ?? sensor.mv1,
          originalmv2: sensor.niv2 ?? sensor.mv2,
          originalmv3: sensor.niv3 ?? sensor.mv3,
          altitude: sensor.altitude,
          mapping: dataMappings.filter((mapping) => mapping.sensor_id === sensor.sensor_id),
          fieldId: data,
        };
      });

      setSensorData(sensors);
      setAllDataSensor(updatedSensorData);
    } catch (error) {
      console.log(error);
    }
  };
  console.log(fieldUid, " fieldUid in useSensorData");

  useEffect(() => {
    getDataSensor();

    // ✅ Connexion Socket.IO
    const newSocket = io(`${process.env.REACT_APP_BASE_URL_SOCKET}`, {
      transports: ["websocket"],
      reconnection: true,
    });

    newSocket.on("connect", () => {
      console.log("✅ Socket connecté pour sensor data");
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?.uid) {
        newSocket.emit("register_user", user.uid);
      }
    });

    // ✅ Écouter les mises à jour de capteur
    newSocket.on("sensor_data_update", (newSensorData) => {
      console.log("📡 Nouvelles données capteur reçues:", newSensorData);

      // Mettre à jour seulement le capteur concerné
      setAllDataSensor((prevData) => {
        const existingIndex = prevData.findIndex(
          (s) => s.sensor_id === newSensorData.sensor_id
        );

        if (existingIndex !== -1) {
          // Mettre à jour le capteur existant
          // Récupérer le mapping du capteur existant
          getDataSensor();
          return prevData;
          
          // Appliquer le mapping aux nouvelles données
        } else {
          // Ajouter nouveau capteur
          return [...prevData, newSensorData];
        }
      });
    });

    newSocket.on("field_status_updated", (fieldStatus) => {
      window.dispatchEvent(
        new CustomEvent("smartfarm:field-status-updated", {
          detail: fieldStatus,
        }),
      );
    });

    newSocket.on("irrigation_advice_updated", (advice) => {
      window.dispatchEvent(
        new CustomEvent("smartfarm:irrigation-advice-updated", {
          detail: advice,
        }),
      );
    });

    setSocket(newSocket);

    // ✅ Cleanup
    return () => {
      if (newSocket) {
        newSocket.off("field_status_updated");
        newSocket.off("irrigation_advice_updated");
        newSocket.disconnect();
      }
    };
  }, [fieldUid, location.pathname, userId, userUid]);

  return allDataSensor;
};
export default useSensorData;
